<div id="confirmModal" [ngClass]="modalClass">
    @if (message) {
        <div class="modalTile">
            <!-- Schliessen Button -->
            <div class="closeMe" data-dismiss="modal" (click)="close()" title="{{txtClose}}"></div>
            <!-- Ueberschrift -->
            <div class="headline">
                {{ message.headline }}
            </div>

            @if (message.details.length > 0) {
                <div class="warning">
                    <div class="warningIconWrapper">
                        <!-- Icons der Warnungen -->
                        <div class="ic"><i class="icon ico-info">&#160;</i></div>
                    </div>
                    <div class="warningMessageWrapper">
                        <!-- Inhalt -->
                        @for (detail of message.details; track detail) {
                            <div>{{ detail }}</div>
                        }
                    </div>
                </div>
            }

            <div class="modalContent">
                <div class="gridContainer fitGrid">
                    <div class="row">
                        <div class="cell grid-50">
                            <button class="btn-grau" data-dismiss="modal" (click)="close()">
                                Nein
                            </button>
                        </div>
                        <div class="cell grid-50">
                            <button class="btn-orange" (click)="accept()">
                                Ja
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
</div>
